/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

type PictoChartContextValue = {
  supportsSelection?: boolean;
};

const PictoChartContext = createContext<PictoChartContextValue>({} as PictoChartContextValue);
const usePictoChartContext = () => useContext(PictoChartContext);

export { PictoChartContext, usePictoChartContext };
